<div class="transaction-status">
  @if (data.status == true && data.flw_status.toLowerCase() =='successful') {
    <img class="mx-auto" src="../../assets/successful-transaction-icon.svg" alt="">
    <h3 class="status-head mb-0">
      Woo hoo!!
    </h3>
    <p class="status-description mb-0">
      Congrats ! transaction successful
    </p>
    <p class="status-description mb-0">
      {{data.message}}
    </p>
    <button (click)="activeModal.close()" class="btn success-btn">
      Done
    </button>
  } @else {
    <img class="mx-auto" src="../../assets/failed-transaction-icon.svg" alt="">
    <h3 class="status-head mb-0">
      Oooops!!
    </h3>
    <p class="status-description mb-0">
      Sorry! transaction failed
    </p>
    <p class="status-description mb-0">
      {{data.message}}
    </p>
    <button (click)="activeModal.close()" class="btn success-btn">
      Try Again
    </button>
    <button (click)="activeModal.dismiss()" class="btn failed-btn">
      Exit
    </button>
  }

</div>
